import { Injectable } from '@angular/core';

/*
  Generated class for the LocationServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
    providedIn: 'root'
})
export class LocationServiceProvider {

  public latitude: Number;
  public longitude: Number;
  public valid: boolean;

  constructor() {
    this.latitude = 50.930277;//0.0;
    this.longitude = 4.806417;//0.0;
    this.valid = false;
  }

  updateValue(newLat: Number, newLng: Number) {
    this.latitude = newLat;
    this.longitude = newLng;
    this.valid = true;
    this.showInfo();
  }

  showInfo() {
    console.log("[LOCATION-SERVICE] lat: " + this.latitude + " lng : " + this.longitude + " valid: " + this.valid);
  }

}
